/* eslint-disable max-len */
import React from 'react';
import { Box, Typography } from '@mui/material';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import TuneIcon from '@mui/icons-material/Tune';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined';
import VolunteerActivismOutlinedIcon from '@mui/icons-material/VolunteerActivismOutlined';

const WhyUs = () => (
  <Box
    id="whyus"
    sx={{
      width: '100%', padding: { xs: '30px 50px', sm: '60px 100px' }, background: '#fff', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
    }}
  >
    <Box sx={{ width: '100%', textAlign: 'center' }}>
      <Typography sx={{ fontWeight: '500', fontSize: '20px', color: '#1A76D2' }}>Why Us</Typography>
      <Typography sx={{ fontWeight: '700', fontSize: { xs: '30px', sm: '40px' }, color: '#243E63' }}>
        We have Amazing
        <span style={{ color: '#1A76D2' }}> Services</span>
      </Typography>
      <Typography sx={{
        width: { xs: '100%', sm: '50%' }, fontWeight: '300', fontSize: '18px', margin: '5px auto', color: '#ADB5C3',
      }}
      >
        Your Experience Gets Better And Better Over Time.
      </Typography>
    </Box>
    <Box sx={{
      width: '100%', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyConent: 'center', alignItems: 'center', gap: { xs: '24px', sm: '40px' }, margin: '40px auto',
    }}
    >

      <Box sx={{
        width: '100%', textAlign: 'left', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: 'center', gap: { xs: '24px', sm: '0' },
      }}
      >
        <Box sx={{
          width: { xs: '100%', sm: '30%' }, textAlign: 'left', display: 'flex', flexDirection: 'row', gap: '15px',
        }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <ShieldOutlinedIcon sx={{
              fontSize: '50px', border: '1px solid #243E63', borderRadius: '100%', padding: '10px',
            }}
            />
          </Box>
          <Box>
            <Typography sx={{ fontWeight: '500', fontSize: '25px', color: '#243E63' }}>Secure</Typography>
            <Typography sx={{
              width: '100%', fontWeight: '500', fontSize: '15px', color: '#243E63',
            }}
            >
              Your content is protected. Our vetted workforce only uses secure tools.
            </Typography>
          </Box>
        </Box>
        <Box sx={{
          width: { xs: '100%', sm: '30%' }, textAlign: 'left', display: 'flex', flexDirection: 'row', gap: '15px',
        }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <SupportAgentRoundedIcon sx={{
              fontSize: '50px', border: '1px solid #243E63', borderRadius: '100%', padding: '10px',
            }}
            />
          </Box>
          <Box>
            <Typography sx={{ fontWeight: '500', fontSize: '25px', color: '#243E63' }}>24/7 Support</Typography>
            <Typography sx={{
              width: '100%', fontWeight: '500', fontSize: '15px', color: '#243E63',
            }}
            >
              Our team is available 24/7. Reach out to us at any time.
            </Typography>
          </Box>
        </Box>
        <Box sx={{
          width: { xs: '100%', sm: '30%' }, textAlign: 'left', display: 'flex', flexDirection: 'row', gap: '15px',
        }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <TuneIcon sx={{
              fontSize: '50px', border: '1px solid #243E63', borderRadius: '100%', padding: '10px',
            }}
            />
          </Box>
          <Box>
            <Typography sx={{ fontWeight: '500', fontSize: '25px', color: '#243E63' }}>Powerful Technology</Typography>
            <Typography sx={{
              width: '100%', fontWeight: '500', fontSize: '15px', color: '#243E63',
            }}
            >
              Our powerful software platform makes it easy to deliver high-quality results quickly.
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box sx={{
        width: '100%', textAlign: 'left', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: 'center', gap: { xs: '24px', sm: '0' },
      }}
      >
        <Box sx={{
          width: { xs: '100%', sm: '30%' }, textAlign: 'left', display: 'flex', flexDirection: 'row', gap: '15px',
        }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CheckCircleOutlineOutlinedIcon sx={{
              fontSize: '50px', border: '1px solid #243E63', borderRadius: '100%', padding: '10px',
            }}
            />
          </Box>
          <Box>
            <Typography sx={{ fontWeight: '500', fontSize: '25px', color: '#243E63' }}>Reliable</Typography>
            <Typography sx={{
              width: '100%', fontWeight: '500', fontSize: '15px', color: '#243E63',
            }}
            >
              Professional transcriptionists, captioners, and translators who are vetted for quality.
            </Typography>
          </Box>
        </Box>
        <Box sx={{
          width: { xs: '100%', sm: '30%' }, textAlign: 'left', display: 'flex', flexDirection: 'row', gap: '15px',
        }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <BoltOutlinedIcon sx={{
              fontSize: '50px', border: '1px solid #243E63', borderRadius: '100%', padding: '10px',
            }}
            />
          </Box>
          <Box>
            <Typography sx={{ fontWeight: '500', fontSize: '25px', color: '#243E63' }}>Fast</Typography>
            <Typography sx={{
              width: '100%', fontWeight: '500', fontSize: '15px', color: '#243E63',
            }}
            >
              Our 48Hrs Standard turn around time service to serve you best. You can also order express delivered within 8 hours
            </Typography>
          </Box>
        </Box>
        <Box sx={{
          width: { xs: '100%', sm: '30%' }, textAlign: 'left', display: 'flex', flexDirection: 'row', gap: '15px',
        }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <VolunteerActivismOutlinedIcon sx={{
              fontSize: '50px', border: '1px solid #243E63', borderRadius: '100%', padding: '10px',
            }}
            />
          </Box>
          <Box>
            <Typography sx={{ fontWeight: '500', fontSize: '25px', color: '#243E63' }}>Easy</Typography>
            <Typography sx={{
              width: '100%', fontWeight: '500', fontSize: '15px', color: '#243E63',
            }}
            >
              Transparent pricing so you know the cost before purchasing.
            </Typography>
          </Box>
        </Box>
      </Box>

    </Box>
  </Box>
);

export default WhyUs;
